import { SHARED_HERO_CREDIBILITY } from "./medicalHeroContent";

export const SALES_HERO_SUBHEADING =
  "REPEXO Sales Personalberatung – Headhunting für Top-Vertriebsteams.";

export const SALES_HERO_INTRO =
  "Seit über 45 Jahren im Vertreib  unterstützt REPEXO Unternehmen beim Aufbau leistungsstarker Vertriebsorganisationen. Mit unserem Fokus auf Sales-Positionen kennen wir die Dynamik von Vertrieb, Key Account Management und Business Development und wissen, welche Persönlichkeiten echten Umsatz und nachhaltiges Wachstum bringen.";

export const SALES_HERO_CREDIBILITY = {
  ...SHARED_HERO_CREDIBILITY,
  stats: [
    { value: "45+", label: "Jahre Erfahrung" },
    { value: "5400+", label: "erfolgreiche Personalsuch-Mandate" },
    SHARED_HERO_CREDIBILITY.stats[2],
  ],
};

export const SALES_HERO_BOTTOM_PARAGRAPH =
  "Als spezialisierte Personalberatung im Bereich Direktansprache / Executive Search identifizieren wir gezielt Vertriebspersönlichkeiten im verdeckten Arbeitsmarkt – vom Außendienst bis zur Vertriebsleitung. Durch unser Netzwerk, unsere Erfahrung und eine strukturierte Suchmethodik besetzen wir kritische Sales-Rollen passgenau und stärken so die Wettbewerbsfähigkeit unserer Kunden.";

